import { Col, Row, Typography } from 'antd';
import { useGetOnePatientProfileSysAdminQuery } from 'api/SysAdminApi';
import SysAdminLifeReviewResponseListComponent from 'components/SysAdmin/SysAdminLifeReviewResponseListComponent/SysAdminLifeReviewResponseListComponent';
import SysAdminMessageListComponent from 'components/SysAdmin/SysAdminMessageListComponent/SysAdminMessageListComponent';
import SysAdminPreviewMessageModalComponent from 'components/SysAdmin/SysAdminPreviewMessageModalComponent/SysAdminPreviewMessageModalComponent';

type AllProps = {
  patientProfileId: string;
};

function SysAdminPatientProfileDetailsComponent({ patientProfileId }: AllProps) {
  const { data: patientProfileData } = useGetOnePatientProfileSysAdminQuery(
    {
      patientProfileId
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  const displayName =
    patientProfileData?.displayName || `${patientProfileData?.firstName || ''} ${patientProfileData?.lastName || ''}`.trim() || 'Unnamed profile';

  const portalAccessLabel =
    patientProfileData?.portalAccessStatus === 'registered'
      ? 'Registered'
      : patientProfileData?.portalAccessStatus === 'invite_sent'
      ? 'Invite sent'
      : 'Profile only';

  const lifecycleStatus = patientProfileData?.lifecycleStatus || (patientProfileData as { status?: string | null } | undefined)?.status;

  const lifecycleStatusLabel =
    lifecycleStatus === 'active'
      ? 'Active'
      : lifecycleStatus === 'unverified_deceased'
      ? 'Unverified Deceased'
      : lifecycleStatus === 'deceased'
      ? 'Deceased'
      : lifecycleStatus === 'memorial'
      ? 'Memorial'
      : 'N/A';

  return (
    <>
      <div className="sys-admin-user-list-component">
        <Typography>
          <h2>{displayName}</h2>
        </Typography>

        <Row gutter={[0, 10]}>
          <Col xs={12}>Email: {patientProfileData?.email || 'No email on file'}</Col>
          <Col xs={12}>Phone: {patientProfileData?.phone || 'No phone on file'}</Col>
          <Col xs={12}>Lifecycle Status: {lifecycleStatusLabel}</Col>
          <Col xs={12}>Portal Access: {portalAccessLabel}</Col>
          <Col xs={12}>Total messages: {patientProfileData?.messagesCount || 0}</Col>
          <Col xs={12}>Completed messages: {patientProfileData?.messagesPublishedCount || 0}</Col>
          <Col xs={12}>Life review responses: {patientProfileData?.lifeReviewResponsesCount || 0}</Col>
          <Col xs={12}>Created at: {patientProfileData?.createdAt || 'N/A'}</Col>
          <Col xs={12}>Updated at: {patientProfileData?.updatedAt || 'N/A'}</Col>
        </Row>

        <SysAdminMessageListComponent userId={patientProfileData?.userId || undefined} patientProfileId={patientProfileId} />
        <SysAdminLifeReviewResponseListComponent userId={patientProfileData?.userId || undefined} patientProfileId={patientProfileId} />
      </div>

      <SysAdminPreviewMessageModalComponent />
    </>
  );
}

export default SysAdminPatientProfileDetailsComponent;